import DropDown from './DropDown';
import { Link } from 'react-router-dom';

export default function Nav({ setMobileToggle }) {
  return (
    <ul className="cs_nav_list fw-medium">
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Home
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Sobre
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Gateway
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Checkout
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Quiz Builder
        </Link>
      </li>
      <li>
        <Link to="/" onClick={() => setMobileToggle(false)}>
          Taxas
        </Link>
      </li>
    </ul>
  );
}
